import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { AddTargetNotificationComponent } from './../../shared/components/add-target-notification/add-target-notification.component';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationService } from 'src/app/providers/navigation.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'sm-promotion',
  templateUrl: './promotion.component.html',
  styleUrls: ['./promotion.component.scss'],
})
export class PromotionComponent implements OnInit, OnDestroy {
  public totalAdminPost: number = 0;
  public totalBuisnessPromotion: number = 0;
  public totalTargetedList: number = 0;
  public totalCouponsList: number = 0;

  public loader: boolean = false;
  private _apiSubscription: Subscription = new Subscription();
  constructor(
    private _navService: NavigationService,
    private _modelRef: MatDialog,
    private _apiService: ApiService
  ) {
    this._navService.hideSidebarAndNav = false;
  }

  ngOnInit(): void {
    this.loader = true;
    this._apiService.getAdminPostListCount('1');
    this._apiService.getBuisnessPromotionListCount('1');
    this._apiService.getTargetedNotificationsList();
    this._apiService.getDiscountCouponsListCount();
    this._apiSubscription = this._apiService.apiResult.subscribe((data) => {
      console.log('data', data);
      if (data.responseType === SM_CONSTANTS.GET_ADMIN_POST_LIST_COUNT_RESULT) {
        if (data.result) {
          this.totalAdminPost = data.result[0].totalRecords;
        } else {
          this.totalAdminPost = 0;
        }
      }
      if (
        data.responseType ===
        SM_CONSTANTS.GET_BUISNESS_PROMOTION_LIST_COUNT_RESULT
      ) {
        if (data.result) {
          this.totalBuisnessPromotion = data.result[0].totalRecords;
        } else {
          this.totalBuisnessPromotion = 0;
        }
      }
      if (
        data.responseType === SM_CONSTANTS.GET_TARGETED_NOTIFICATIONS_RESULT
      ) {
        if (data.result) {
          this.totalTargetedList = data.result?.length;
        } else {
          this.totalTargetedList = 0;
        }
      }
      if (
        data.responseType === SM_CONSTANTS.GET_COUPONS_LIST_COUNT_RESULT
      ) {
        if (data.result) {
          this.totalCouponsList = data.result?.length;
        } else {
          this.totalCouponsList = 0;
        }
      }

      this.loader = false;
    });
  }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
  }
}
